import React from 'react';
import ExternalLink from './ExternalLink';

const MainTerms = () => (
  <p className="main__terms">
    {"By signing in, I agree to Prodigy Finance's "}
    <ExternalLink url="https://prodigy-files.s3.amazonaws.com/files/bVTza_GuG3Zb_1i2inmmyg/Prodigy_Finance_Ltd_EULA.v2.03_January_2023.pdf">
      EULA
    </ExternalLink>
    {' , '}
    <ExternalLink url="https://prodigyfinance.com/legal/terms-of-use">Terms of Service</ExternalLink>
    {' , '}
    <ExternalLink url="https://prodigy-files.s3.amazonaws.com/files/gHXqF7JvpTVTfzPZFwvWIQ/Prodigy_Finance_Privacy_Notice_-_January_2023.pdf">
      Privacy Notice
    </ExternalLink>
    {' and '}
    <ExternalLink url="https://prodigyfinance.com/legal/privacy-policy">Privacy Policy</ExternalLink>
  </p>
);

export default MainTerms;
